import { useQuery } from '@tanstack/react-query';

import { CardIssuingApiService } from '@ClientApi/cardIssuing';
import { Vendor } from '@Shared/interfaces/CardsGatewayInterfaces';

export const ALLOWED_VENDORS_QUERY_KEY_ROOT = 'ALLOWED_VENDORS';
export const ALLOWED_VENDORS_QUERY_KEY_GRID = 'GRID';

const _ALLOWED_VENDORS_PLACEHOLDER_DATA: Vendor[] = [];

export const useAllowedVendorsQuery = () => {
  const queryInfo = useQuery(
    [ALLOWED_VENDORS_QUERY_KEY_ROOT, ALLOWED_VENDORS_QUERY_KEY_GRID],
    async () => {
      return await CardIssuingApiService.getVendors();
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 5000,
      placeholderData: _ALLOWED_VENDORS_PLACEHOLDER_DATA
    }
  );

  return queryInfo;
};
